import type { ReactNode } from 'react';
import { styled } from 'styled-components';

import { cssBreakpoints } from '#/theme/theme';

type Props = {
  children: ReactNode;
};

const DetailsListRowContainer = styled.div`
  display: flex;
  gap: 16px;

  @media (max-width: ${cssBreakpoints.mdDown}) {
    flex-direction: column;
  }
`;

export function DetailsListRow({ children }: Props) {
  return <DetailsListRowContainer>{children}</DetailsListRowContainer>;
}
